import React from 'react'

var API = require('../api');

export default class Giphy extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			url: null
		}
	}
	componentDidMount() {
		this.apiRefresh = setInterval(this.fetchData.bind(this), 5 * 60 * 1000); // 5 minutes
		this.fetchData();
	}

	componentWillUnmount() {
		if (this.apiRefresh) {
			clearTimeout(this.apiRefresh)
		}
	}

	fetchData() {
		API.fetchGiphyAnim()
			.then(response => {
				this.setState({
					url: response.data.images.downsized_medium.url,
				});
			})
			.catch(error => {
				this.setState({
					url: "https://media2.giphy.com/media/hI7hLr2PMzoJO/giphy.gif"
				});
			});
	}

	render() {
		return this.state.url
			? <img src={this.state.url} width="250" alt="Amazing!" />
			: null;
	}
};


// WEBPACK FOOTER //
// ./src/widgets/giphy.jsx